import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c(VDialog, {
    attrs: {
      width: "1000",
      persistent: ""
    },
    on: {
      keydown: function keydown($event) {
        if (!$event.type.indexOf("key") && _vm._k($event.keyCode, "esc", 27, $event.key, ["Esc", "Escape"])) return null;
        return _vm.closeDialog.apply(null, arguments);
      }
    },
    model: {
      value: _vm.dialog,
      callback: function callback($$v) {
        _vm.dialog = $$v;
      },
      expression: "dialog"
    }
  }, [_c(VCard, [_c("div", {
    staticClass: "dialog-closer --t-2"
  }, [_c(VIcon, {
    staticClass: "far fa-times-circle",
    attrs: {
      disabled: _vm.loadingDocumentTags
    },
    on: {
      click: _vm.closeDialog
    }
  })], 1), _c(VCardTitle, {
    staticClass: "headline"
  }, [_c("div", {
    staticClass: "text-h5"
  }, [_vm._v("Add tag to document")])]), _c(VForm, {
    staticClass: "dfwa-form pa-8",
    model: {
      value: _vm.form.valid,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "valid", $$v);
      },
      expression: "form.valid"
    }
  }, [_vm.documentTags.length ? _c(VAutocomplete, {
    staticClass: "v-text-field-no-label required",
    attrs: {
      items: _vm.documentTags,
      "hide-no-data": "",
      "hide-selected": "",
      "item-value": "id",
      "item-text": "name",
      placeholder: "Tag",
      "hide-details": "auto",
      rules: [_vm.formRules.mustNotBeEmpty],
      loading: _vm.loadingDocumentTags,
      label: "Document tag"
    },
    model: {
      value: _vm.idTag,
      callback: function callback($$v) {
        _vm.idTag = $$v;
      },
      expression: "idTag"
    }
  }) : _c("div", [_c("p", [_vm._v("There are no tags available, you must add at least one.")]), _c(VBtn, {
    staticClass: "dfwa-btn --small secondary",
    attrs: {
      loading: _vm.form.loading,
      rounded: ""
    },
    on: {
      click: function click($event) {
        return _vm.emitManageTagsDialog();
      }
    }
  }, [_vm._v(" Add tags ")])], 1)], 1), _c(VCardActions, [_c(VBtn, {
    staticClass: "dfwa-btn --small secondary",
    attrs: {
      loading: _vm.form.loading,
      rounded: ""
    },
    on: {
      click: _vm.closeDialog
    }
  }, [_vm._v(" Cancel ")]), _c(VBtn, {
    staticClass: "dfwa-btn --small",
    attrs: {
      loading: _vm.form.loading,
      disabled: !_vm.form.valid || !_vm.documentTags.length,
      rounded: ""
    },
    on: {
      click: _vm.addTagToDocument
    }
  }, [_vm._v(" Save ")])], 1)], 1)], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };